export enum UserAccess {
  Free = 'Free',
  Premium = 'Premium',
  Founder = 'Founder',
  Visitor = 'Visitor',
}

export interface AuthInfos {
  userAccess: UserAccess,
  // corporate: boolean
  userAirTableId: string,
  userEmail: string,
}

export const authInfosDefaults: AuthInfos = {
  userAccess: UserAccess.Visitor,
  // corporate: false,
  userAirTableId: '',
  userEmail: ''
}
